<template>
  <MenuComponent modulo="parametros" :menuInferior="menuInferior"/>
  <main class="items-center w-full px-4 py-4 mx-auto my-10 bg-white rounded-lg shadow-md sm:w-11/12">
    <router-view v-slot="{ Component }">
      <Suspense timeout="0">
        <template #default>
          <div class="container mx-auto">
            <component :is="Component"></component>
          </div>
        </template>
        <template #fallback>
          <div class="container mx-auto">
            <LoadingComponent></LoadingComponent>
          </div>
        </template>
      </Suspense>
    </router-view>
  </main>
</template>
<script>
import MenuComponent from "@/layouts/MenuComponent";
import LoadingComponent from "@/layouts/LoadingComponent";
import {ref} from 'vue';

/**
 @component MenuParametros
 @description Componente que muestra el menú de navegación y la vista principal de la página de Parámetros.
 @template
 @prop {String} modulo - Nombre del módulo al que pertenece el menú de navegación.
 @prop {Array} menuInferior - Lista de elementos del menú de navegación inferior.
 @slot - Ranura para el componente de enrutamiento de Vue.
 @slot default - Ranura para el componente de la página actual.
 @slot fallback - Ranura para mostrar un componente de carga mientras se cargan los datos de la página actual.
 @example
 <MenuParametros />
 */
export default {
  name: "MenuParametros",
  components: {MenuComponent, LoadingComponent},
  setup() {
    /**
     * Carga el menú inferior con los elementos correspondientes según el rol del usuario.
     * @function cargarMenuInferior
     * @returns {Array} - Lista de objetos que representan los elementos del menú inferior.
     */

    const cargarMenuInferior = () => {
      const userStored = JSON.parse(localStorage.getItem("user"));
      const elementos = [];

      let idPadre = '';
      
      let newPermisos = userStored.permisosUsuariosEntities.concat(userStored.rol.permisosRolesEntities);

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso.menu
        if(dataMenu.name == 'MenuParametros'){
          idPadre = dataMenu.id
        }
      }

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso
    
        if(dataMenu.estado)
        {
          if(dataMenu.menu.menu_padre_id == idPadre && dataMenu.menu.estado)
          {
            const result = elementos.find(({ name }) => name === dataMenu.menu.name);
            if(!result){
              elementos.push({
                alias: dataMenu.menu.alias, 
                name:  dataMenu.menu.name,
                current: (dataMenu.menu.name == 'BancosCRUD') ? true : false   
              });
            }
          }
        }
      }

      // elementos.push({alias: "Bancos", name: "BancosCRUD", current: true});
      // elementos.push({alias: "Cuentas Bancarias", name: "CuentasBancariasCRUD", current: false});
      // if (userStored.rol.nombre !== "user") {
      //   elementos.push({alias: "Secretarías Ejecutoras", name: "SecretariasEjecutorasCRUD", current: false});
      //   elementos.push({alias: "Contratos", name: "ContratosCRUD", current: false});
      //   elementos.push({alias: "Caps", name: "CapsCRUD", current: false});
      //   elementos.push({alias: "Fuentes financiaciones", name: "FuentesFinanciacionesCRUD", current: false});
      //   elementos.push({alias: "Fuentes concretas", name: "FuentesConcretasCRUD", current: false});
      //   elementos.push({alias: "Rubros", name: "RubrosCRUD", current: false});
      //   elementos.push({alias: "Beneficiarios", name: "BeneficiariosCRUD", current: false});
      
      return elementos;
    };

    const menuInferior = ref(cargarMenuInferior());
    return {
      /**
       * Lista de elementos del menú inferior.
       * @memberof MenuParametros
       * @type {Array}
       */
      menuInferior: menuInferior
    };
  },
};
</script>